export const useGetter = function () {
    var username = localStorage.getItem('username');
    var userarea = localStorage.getItem('userarea');
    var usercode = localStorage.getItem('usercode');
    try {
        var Jwt = JSON.parse(localStorage.getItem('token'));
    } catch (e) {
        console.log(e)
    }
    if (Jwt != null && Jwt.hasOwnProperty("value")) {
        var token = Jwt.value;
    } else {
        return false;
    }
    if
    (
    username === undefined
    ) {
        return false;
    }
    return {
        username: username,
        token: token,
        usercode: usercode,
        userarea: userarea
    };
};




//////////////////
// WEBPACK FOOTER
// ./api/local.js
// module id = xtsT
// module chunks = 0